export default {
    menu: {
        addToWorkspace: 'Add to work space',
        removeFromWorkspace: 'Remove from work space',
        pinToMacrotrend: 'Pin to macro-trend'
    },
    tooltip: {
        workspace: 'Add to work space or remove from this work space',
        all: 'Add to work space,<br />remove from this work space<br />or pin to a macro-trend',
        pin: 'Pin to a macro-trend'
    }
}
